export default "__VITE_ASSET__EeyScY$Y__"